/**
 * Client mirror of functions/src/prest0nSession/stepLimitNarration.ts.
 *
 * WS-0 0.6 (PLAN-deliverable-formatting-unification-20260811): the resume
 * finalizer's step-limit regex had drifted from the server persist gate's
 * copy (it was missing the ZERO_TOOLS_DEADEND_RESPONSE clause). The two build
 * targets cannot share a module today, so this file MUST stay byte-identical
 * in its exports to the functions copy — enforced by
 * tests/orchestrator/stepLimitNarrationParity.test.ts.
 */

export const STEP_LIMIT_NARRATION_PATTERN =
  "within my step limit|hit my step limit|didn't complete on my first pass|Here's where this stands|couldn't finish this request cleanly";

const STEP_LIMIT_NARRATION_RE = new RegExp(STEP_LIMIT_NARRATION_PATTERN, 'i');

export function isStepLimitNarration(text: string | null | undefined): boolean {
  return STEP_LIMIT_NARRATION_RE.test(String(text || ''));
}

/**
 * Cheap Spanish-likelihood heuristic for the last-resort notice below when no
 * explicit language rides the record (review F2). Strong markers only:
 * inverted punctuation, ñ, or two accented vowels.
 */
export function detectSpanishLikely(text: string | null | undefined): boolean {
  const value = String(text || '');
  if (/[¿¡ñÑ]/.test(value)) return true;
  return (value.match(/[áéíóúÁÉÍÓÚ]/g) || []).length >= 2;
}

/**
 * Last-resort body for a turn that carries attachments but no usable text.
 * An attachment-bearing turn must never render an empty bubble above its
 * download cards.
 */
export function buildAttachmentsReadyNotice(
  names: ReadonlyArray<string>,
  language?: 'en' | 'es',
): string {
  const clean = names.map((n) => String(n || '').trim()).filter(Boolean);
  const isEs = language === 'es';
  if (clean.length === 0) {
    return isEs ? 'Tus archivos están listos para descargar.' : 'Your files are ready to download.';
  }
  const list = clean.join(', ');
  if (clean.length === 1) {
    return isEs ? `Tu archivo está listo: ${list}.` : `Your file is ready: ${list}.`;
  }
  return isEs ? `Tus archivos están listos: ${list}.` : `Your files are ready: ${list}.`;
}
